import { render, staticRenderFns } from "./SubLayout.vue?vue&type=template&id=0803188a&scoped=true"
import script from "./SubLayout.vue?vue&type=script&lang=js"
export * from "./SubLayout.vue?vue&type=script&lang=js"
import style0 from "./SubLayout.vue?vue&type=style&index=0&id=0803188a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0803188a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/src/Web/InternetBranch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0803188a')) {
      api.createRecord('0803188a', component.options)
    } else {
      api.reload('0803188a', component.options)
    }
    module.hot.accept("./SubLayout.vue?vue&type=template&id=0803188a&scoped=true", function () {
      api.rerender('0803188a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SubLayout.vue"
export default component.exports